// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    ResourcePageResponse,
    ResourcePageResponseFromJSON,
    ResourcePageResponseToJSON,
    ResourceRequest,
    ResourceRequestFromJSON,
    ResourceRequestToJSON,
    ResourceResponse,
    ResourceResponseFromJSON,
    ResourceResponseToJSON,
    ResourceType,
    ResourceTypeFromJSON,
    ResourceTypeToJSON,
  } from '../models';

      export interface CreateResourceRequest {
        resource: ResourceRequest;
        file?: Blob;
      }

      export interface DeleteResourceRequest {
        resourceId: number;
      }

      export interface GetResourceRequest {
        resourceId: number;
      }

      export interface GetResourcesRequest {
        page?: number;
        pageSize?: number;
        query?: string;
        type?: ResourceType;
      }

      export interface RestoreResourceRequest {
        resourceId: number;
      }

      export interface UpdateResourceRequest {
        resourceId: number;
        resource: ResourceRequest;
        file?: Blob;
      }


/**
* no description
*/
export interface ResourcesApi {
    /**
      * Post a new resource
    */
    createResource(requestParameters: CreateResourceRequest): Promise<ResourceResponse>
    /**
      * Delete a resource
    */
    deleteResource(requestParameters: DeleteResourceRequest): Promise<void>
    /**
      * Get a resource
    */
    getResource(requestParameters: GetResourceRequest): Promise<ResourceResponse>
    /**
      * Get a page of resources for the currently authenticated user
    */
    getResources(requestParameters: GetResourcesRequest): Promise<ResourcePageResponse>
    /**
      * Restore a resource
    */
    restoreResource(requestParameters: RestoreResourceRequest): Promise<ResourceResponse>
    /**
      * Update a resource
    */
    updateResource(requestParameters: UpdateResourceRequest): Promise<ResourceResponse>
}

  /**
  * no description
  */
  export class ResourcesApiImpl extends runtime.BaseAPI implements ResourcesApi {

    /**
      * Post a new resource
    */
    async createResourceRaw(requestParameters: CreateResourceRequest): Promise<runtime.ApiResponse<ResourceResponse>> {
          if (requestParameters.resource === null || requestParameters.resource === undefined) {
          throw new runtime.RequiredError('resource','Required parameter requestParameters.resource was null or undefined when calling createResource.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
        const formData = new FormData();
            if (requestParameters.file !== undefined) {
              formData.append('file', requestParameters.file as any);
            }
          if (requestParameters.resource !== undefined) {
            formData.append('resource', new Blob([JSON.stringify(requestParameters.resource)], { type: 'application/json' }));
          }
      const response = await this.request({
      path: `/resources`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
        body: formData,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ResourceResponseFromJSON(jsonValue));
      }

      /**
        * Post a new resource
      */
      async createResource(requestParameters: CreateResourceRequest): Promise<ResourceResponse> {
        const response = await this.createResourceRaw(requestParameters);
        return await response.value();
      }

    /**
      * Delete a resource
    */
    async deleteResourceRaw(requestParameters: DeleteResourceRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
          throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling deleteResource.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/resources/{resourceId}`.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Delete a resource
      */
      async deleteResource(requestParameters: DeleteResourceRequest): Promise<void> {
        await this.deleteResourceRaw(requestParameters);
      }

    /**
      * Get a resource
    */
    async getResourceRaw(requestParameters: GetResourceRequest): Promise<runtime.ApiResponse<ResourceResponse>> {
          if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
          throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling getResource.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/resources/{resourceId}`.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ResourceResponseFromJSON(jsonValue));
      }

      /**
        * Get a resource
      */
      async getResource(requestParameters: GetResourceRequest): Promise<ResourceResponse> {
        const response = await this.getResourceRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a page of resources for the currently authenticated user
    */
    async getResourcesRaw(requestParameters: GetResourcesRequest): Promise<runtime.ApiResponse<ResourcePageResponse>> {
      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.query !== undefined) {
              queryParameters['query'] = requestParameters.query;
          }

          if (requestParameters.type !== undefined) {
              queryParameters['type'] = requestParameters.type;
          }

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/account/resources`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ResourcePageResponseFromJSON(jsonValue));
      }

      /**
        * Get a page of resources for the currently authenticated user
      */
      async getResources(requestParameters: GetResourcesRequest): Promise<ResourcePageResponse> {
        const response = await this.getResourcesRaw(requestParameters);
        return await response.value();
      }

    /**
      * Restore a resource
    */
    async restoreResourceRaw(requestParameters: RestoreResourceRequest): Promise<runtime.ApiResponse<ResourceResponse>> {
          if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
          throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling restoreResource.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/resources/{resourceId}/restore`.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ResourceResponseFromJSON(jsonValue));
      }

      /**
        * Restore a resource
      */
      async restoreResource(requestParameters: RestoreResourceRequest): Promise<ResourceResponse> {
        const response = await this.restoreResourceRaw(requestParameters);
        return await response.value();
      }

    /**
      * Update a resource
    */
    async updateResourceRaw(requestParameters: UpdateResourceRequest): Promise<runtime.ApiResponse<ResourceResponse>> {
          if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
          throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling updateResource.');
          }

          if (requestParameters.resource === null || requestParameters.resource === undefined) {
          throw new runtime.RequiredError('resource','Required parameter requestParameters.resource was null or undefined when calling updateResource.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
        const formData = new FormData();
            if (requestParameters.file !== undefined) {
              formData.append('file', requestParameters.file as any);
            }
          if (requestParameters.resource !== undefined) {
            formData.append('resource', new Blob([JSON.stringify(requestParameters.resource)], { type: 'application/json' }));
          }
      const response = await this.request({
      path: `/resources/{resourceId}`.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
        body: formData,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ResourceResponseFromJSON(jsonValue));
      }

      /**
        * Update a resource
      */
      async updateResource(requestParameters: UpdateResourceRequest): Promise<ResourceResponse> {
        const response = await this.updateResourceRaw(requestParameters);
        return await response.value();
      }

    }
